export const IconLayout = () => {
  const pixelSize = 24;

  return (
    <svg
      width={pixelSize}
      height={pixelSize}
      viewBox={`0 0 ${pixelSize} ${pixelSize}`}
    >
      <path
        d="M5 13h14v2H5v-2zm0 4h8v2H5v-2zM1 3v18a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2zm2 0h18v18H3V3z"
        fill="currentColor"
      />
    </svg>
  );
};
